import { decompressFromBase64 } from "lz-string";

export default function useStateFromQuery<T>(): Partial<T> {
	let parsed: Partial<T>;

	try {
		const raw = window.location.search.replace(/^\?/, "");
		const decompressed = decompressFromBase64(raw);
		parsed = JSON.parse(decompressed);
	} catch (e) {
		console.warn("Failed to decompress the query string, ignoring");
		return {};
	}

	if (!parsed) return {};

	return parsed;
}
